import { LoanType } from '@apply/constants';
import { BfiApi, IApiResponse } from './bfiApi';

export interface IBorrowers extends IApiResponse {
    id: number;
    name: string;
}

export interface ILendingLimitSearch {
    borrowerPrincipalId: number;
    borrowerName: string;
    businessName: string;
    hasMultipleTopLevelBusinesses: boolean;
    borrowerEntities: ILendingLimitBorrowerEntity[];
}

export interface ILendingLimitBorrowerEntity {
    name: string;
    entityId: number;
    product: string;
    builtSince2011: number;
    gcBonus: number;
    loans: ILendingLimitLoan[];
}

export interface ILendingLimitLoan {
    loanNumber: string;
    bfiNumber: string;
    loanType: LoanType;
    commitmentAmount: number;
    outstandingBalance: number;
    repaidAmount: number;
    isOutstanding: boolean;
    repaymentDate?: Date;
    principalPaymentReceived: number;
    ytdInterestPaid: number;
    financedBfiFees: number;
    ltv: number;
    appraisedValue: number;
}

export class LendingLimitApi extends BfiApi {
    getPrincipals(): Promise<IBorrowers> {
        return super.get('/lendinglimits/principals');
    }

    borrowerLendingLimitSearch(principalId: number): Promise<IApiResponse> {
        return super.get(`/lendinglimits/principals/${principalId}/loans`);
    }
}
